import { render, staticRenderFns } from "./dailog-task-details.vue?vue&type=template&id=59c6b94e&scoped=true"
import script from "./dailog-task-details.vue?vue&type=script&lang=js"
export * from "./dailog-task-details.vue?vue&type=script&lang=js"
import style0 from "./dailog-task-details.vue?vue&type=style&index=0&id=59c6b94e&prod&lang=scss&scoped=true"
import style1 from "./dailog-task-details.vue?vue&type=style&index=1&id=59c6b94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6b94e",
  null
  
)

export default component.exports